export default __webpack_public_path__ + "static/media/Eye.271408d8.svg";